export default __webpack_public_path__ + "static/media/Machine-Learning-PT.31b263ff.jpg";